import { j as h } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as z } from "../../../../IconBase-CxZyIWw2.js";
const i = s(
  (l, v) => /* @__PURE__ */ h.jsx(
    z,
    {
      ref: v,
      ...l,
      image: (c) => /* @__PURE__ */ h.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 806,
          height: 806,
          fill: "none",
          viewBox: "0 0 806 806",
          ...c,
          children: [
            /* @__PURE__ */ h.jsxs("g", { clipPath: "url(#clip0_1_57)", children: [
              /* @__PURE__ */ h.jsx("path", { fill: "#fff", d: "M0 0h806v806H0z" }),
              /* @__PURE__ */ h.jsx(
                "path",
                {
                  fill: "#016FD0",
                  d: "M0 0h806v435.103l-39.895 62.334L806 552.916V806H0V395.831l24.935-28.674L0 339.729z"
                }
              ),
              /* @__PURE__ */ h.jsx(
                "path",
                {
                  fill: "#fff",
                  d: "M156 562V435h134.077l14.387 18.809L319.326 435H806v118.241s-12.724 8.633-27.446 8.759H509.072l-16.221-20.02V562h-53.148v-34.173s-7.258 4.77-22.955 4.77H398.66V562h-80.473l-14.364-19.209L289.238 562zM0 339.694 30.198 269h52.225l17.138 39.6V269h64.92l10.203 28.622L184.572 269h291.424v14.389S491.317 269 516.495 269l94.553.332 16.845 39.082V269h54.327l14.953 22.45V269H752v127h-54.827l-14.331-22.522V396h-79.82l-8.027-20.02h-21.459L565.643 396h-54.134c-21.664 0-35.513-14.096-35.513-14.096V396h-81.617l-16.197-20.02V396H74.686l-8.022-20.02h-21.39L37.31 396H0z"
                }
              ),
              /* @__PURE__ */ h.jsx(
                "path",
                {
                  fill: "#016FD0",
                  d: "M40.984 285 0 380h26.683l7.562-19.023h43.962L85.729 380H113l-40.945-95zm15.163 22.11 13.4 33.242H42.708zM115 380v-95l37.882.141 22.034 61.249L196.424 285H234v95h-23.798v-70l-25.228 70h-20.875L138.8 310v70zM250 380v-95h77v21.25h-53.156v16.25h51.913v20h-51.913v16.875H327V380zM341 285v95h23.683v-33.749h9.975L403.056 380H432l-31.167-34.999c12.794-1.083 25.986-12.09 25.986-29.18 0-19.992-15.65-30.821-33.112-30.821zm23.683 21.25h27.074c6.497 0 11.219 5.095 11.219 10.001 0 6.311-6.121 9.999-10.866 9.999h-27.427zM461 380h-25v-95h25zM517.662 380h-5.202c-25.175 0-40.46-19.953-40.46-47.109C472 305.064 487.115 285 518.906 285H545v22.5h-27.047c-12.907 0-22.033 10.132-22.033 25.625 0 18.398 10.435 26.125 25.47 26.125h6.215zM569.62 285 529 380h26.445l7.498-19.023h43.57L613.969 380H641l-40.583-95zm15.03 22.11 13.28 33.242h-26.601zM644 380v-95h30.032l38.348 59.687V285H736v95h-29.06l-39.32-61.25V380zM173 545v-94h77v21.024h-53.156v16.079h51.913v19.79h-51.913v16.7H250V545zM551 545v-94h78v21.024h-53.842v16.079h52.334v19.79h-52.334v16.7H629V545zM252.903 545l37.817-46.42L252 451h29.991l23.058 29.412L328.187 451H357l-38.21 47 37.89 47h-29.984l-22.39-28.949L282.46 545zM359 451v94h24.217v-29.683h24.836c21.017 0 36.947-11.104 36.947-32.7 0-17.89-12.492-31.617-33.879-31.617zm24.217 21.257h26.159c6.786 0 11.641 4.147 11.641 10.823 0 6.273-4.829 10.822-11.721 10.822h-26.079zM456 451v94h23.687v-33.397h9.971L518.056 545H547l-31.163-34.631c12.79-1.072 25.982-11.963 25.982-28.874 0-19.782-15.646-30.495-33.112-30.495zm23.687 21.024h27.074c6.493 0 11.219 5.042 11.219 9.897 0 6.242-6.121 9.893-10.87 9.893h-27.423zM639.994 545v-20.407h47.192c6.982 0 10.003-3.763 10.003-7.887 0-3.951-3.013-7.948-10.003-7.948H665.86c-18.536 0-28.86-11.255-28.86-28.151 0-15.074 9.455-29.607 37.001-29.607h45.915l-9.927 21.148h-39.711c-7.594 0-9.931 3.97-9.931 7.763 0 3.895 2.888 8.192 8.688 8.192h22.339c20.662 0 29.626 11.684 29.626 26.981 0 16.444-9.991 29.916-30.751 29.916zM726.994 545v-20.407h47.188c6.982 0 10.007-3.763 10.007-7.887 0-3.951-3.013-7.948-10.007-7.948H752.86c-18.537 0-28.86-11.255-28.86-28.151 0-15.074 9.455-29.607 36.997-29.607h45.919l-9.931 21.148h-39.711c-7.59 0-9.927 3.97-9.927 7.763 0 3.895 2.888 8.192 8.688 8.192h22.335c20.666 0 29.63 11.684 29.63 26.981 0 16.444-9.991 29.916-30.751 29.916z"
                }
              )
            ] }),
            /* @__PURE__ */ h.jsx("defs", { children: /* @__PURE__ */ h.jsx("clipPath", { id: "clip0_1_57", children: /* @__PURE__ */ h.jsx("path", { fill: "#fff", d: "M0 0h806v806H0z" }) }) })
          ]
        }
      )
    }
  )
);
i.displayName = "AmexIcon";
export {
  i as AmexIcon,
  i as default
};
//# sourceMappingURL=index.js.map
